/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-04-02 14:57:26
 */
import config from './config/login'
import axios from '@/utils/request'
export const codeSend = params => axios.post(config.codeSend, params)
export const codeLogin = params => axios.post(config.codeLogin, params) // 登录
export const accountLogin = params => axios.post(config.accountLogin, params) // 账号密码登录
export const userInfo = params => axios.get(config.userInfo, params)
export const passSendCode = params => axios.post(config.passSendCode, params)
export const updatePass = params => axios.post(config.updatePass, params)
export const phoneSendCode = params => axios.post(config.phoneSendCode, params)
export const phoneVerifyCode = params => axios.post(config.phoneVerifyCode, params)
export const updatePhone = params => axios.post(config.updatePhone, params)
export const userCenterInfo = params => axios.get(config.userCenterInfo, params)
export const hbsgslLogin = params => axios.post(config.hbsgslLogin, params)
export const updateInfo = params => axios.post(config.updateInfo, params)
export const uploadImg = params => axios.post(config.uploadImg, params)
export const qhSendMsg = params => axios.post(config.qhSendMsg, params)
export const qhSign = params => axios.post(config.qhSign, params)
export const qhSignCollege = params => axios.post(config.qhSignCollege, params)
export const jssdkSign = params => axios.post(config.jssdkSign, params)
export const leaderPlanLogin = params => axios.post(config.leaderPlanLogin, params)
export const leaderPlanProduct = params => axios.post(config.leaderPlanProduct, params)
export const genVerifyCode = params => axios.post(config.genVerifyCode, params)
